export default __webpack_public_path__ + "static/media/cb.ca2e3a67.mp3";